import api from '../../services/api';

export default {
  state: {
    currentOperationInfoDiagram: null,
    currentOperationInfoStepNode: null,
    currentOperationInfoStepNodeElement: null,
    executionsProgram: null,
    executionDetail: null,
    executionFilter: null
  },
  getters: {
    getCurrentOperationInfoDiagramParseArray: (state) => {
      const list = [];
      if(state.currentOperationInfoDiagram){
        (function iteratorCurrentOperationInfoDiagramParseArray(obj) {
          const { status, name, updatedAt, message } = obj;

          list.push({ status, name, updatedAt, message });

          if(obj.next){
            return iteratorCurrentOperationInfoDiagramParseArray(obj.next)
          }
          else {
            return
          }
        })(state.currentOperationInfoDiagram);
      }
      return list
    },
    getExecutionDetailParseArray: (state) => {
      const list = [];
      if(state.executionDetail){
        (function iteratorCurrentOperationInfoDiagramParseArray(obj) {
          const { status, name, updatedAt, message, attributes } = obj;

          list.push({ status, name, updatedAt, message, attributes });

          if(obj.next){
            return iteratorCurrentOperationInfoDiagramParseArray(obj.next)
          }
          else {
            return
          }
        })(state.executionDetail);
      }
      return list
    }
  },
  mutations: {
    setCurrentOperationInfoDiagram(state, payload){
      state.currentOperationInfoDiagram = payload
    },
    setCurrentOperationInfoStepNode(state, payload){
      state.currentOperationInfoStepNode = payload
    },
    setCurrentOperationInfoStepNodeElement(state, payload){
      state.currentOperationInfoStepNodeElement = payload
    },
    setExecutionsProgram(state, payload){
      state.executionsProgram = payload
    },
    setExecutionDetail(state, payload){
      state.executionDetail = payload
    },
    setExecutionFilter(state, payload){
      state.executionFilter = payload
    }
  },
  actions: {
    apiGetOperationInfoDiagram({ commit }, payload){
      return new Promise((resolve, reject) => {
        api.get(`/executions/${ payload }/plan`)
          .then((data) => {
            commit('setCurrentOperationInfoDiagram', data.data[0])
            resolve()
          }).catch(error => { reject(error) })
      })
    },
    async apiGetExecutionsProgram({ commit }, payload){
      const result = await api.get(`/program_executions`, { params: payload })
      commit('setExecutionsProgram', result.data)
    },
    async apiGetExecutionDetail({commit}, payload){
      const { id, ...params } = payload
      const result = await api.get(`/program_executions/${id}/plan`, { params })
      commit('setExecutionDetail', result.data)
    }
  }
}
